import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { UiDrawerComponent } from '../../molecules/drawer/drawer.component';
import { UiPropertyProgressClip } from '../property-summary-card/property-summary-card.types';

/**
 * Organismo: diálogo de reproducción con playlist lateral.
 *
 * Presentacional: recibe clips y el clip activo; emite selección y cierre.
 */
@Component({
  selector: 'ui-video-playlist-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UiDrawerComponent],
  templateUrl: './video-playlist-dialog.component.html',
  styleUrl: './video-playlist-dialog.component.scss',
  host: { class: 'ui-video-playlist-dialog-host' },
})
export class UiVideoPlaylistDialogComponent {
  readonly title = input('');
  readonly subtitle = input('Avance de obra');
  readonly clips = input<readonly UiPropertyProgressClip[]>([]);
  readonly activeClip = input.required<UiPropertyProgressClip>();

  readonly clipSelect = output<UiPropertyProgressClip>();
  readonly closed = output<void>();

  protected onProgressThumbReady(event: Event): void {
    const video = event.target as HTMLVideoElement;
    if (video.currentTime === 0) {
      video.currentTime = 0.1;
    }
  }
}
